export const getTranslationEndpoints = (locale) => {
    const translationEndpoints = [
        `/addon-app/translations/kompis-merged-translations/en-XZ.json`,
        `/addon-app/translations/kompis-merged-translations/${locale}.json`,
        // Add application specific endpoints.
        `/addon-app/storageone/translations/en-XZ.json`,
        `/addon-app/storageone/translations/${locale}.json`
    ];
    return translationEndpoints;
};
//# sourceMappingURL=translationEndpoints.js.map